const DISH_STATISTICS: Record<string, FoodNutrient> = {
  NANG_LUONG: {
    id: 1,
    name: 'energy',
    key: 'energy',
    title: 'Năng lượng',
    unit: 'kcal',
    isRequired: false
  },
  CHAT_DAM: {
    id: 2,
    name: 'protein',
    key: 'protein',
    title: 'Chất đạm',
    unit: 'g',
    isRequired: true
  },
  CHAT_BOT_DUONG: {
    id: 3,
    name: 'carbohydrate',
    key: 'carbohydrate',
    title: 'Chất bột đường',
    unit: 'g',
    isRequired: true
  },
  CHAT_BEO: {
    id: 4,
    name: 'fat',
    key: 'fat',
    title: 'Chất béo',
    unit: 'g',
    isRequired: false
  },
  RAU_CU: {
    id: 5,
    name: 'vegetable',
    key: 'vegetable',
    title: 'Rau củ',
    unit: 'g',
    isRequired: false
  },
  TRAI_CAY: {
    id: 6,
    name: 'fruit',
    key: 'fruit',
    title: 'Trái cây',
    unit: 'g',
    isRequired: false
  },
  MUOI: {
    id: 7,
    name: 'salt',
    key: 'salt',
    title: 'Muối',
    unit: 'g',
    isRequired: false
  }
};

export default DISH_STATISTICS;
